var lib_core = require("lib-core");
var editor_2d = require("editor-2d");
var ui_extensions = require("ui-extensions");

var FootprintInteractionView = require("../../../shared/extensions/footprintViewer/footprintInteractionView.js");
var FootprintInteractionModel = require("./footprintInteractionModel.js");
var FootprintViewerModel = require("./footprintViewerModel.js");

var FootprintViewerController = function(archLayers, dependencies, configuration) {
    editor_2d.AbstractViewerController.call(this, archLayers, dependencies, configuration);
};

lib_core.inherit(FootprintViewerController, lib_core.Controller);
FootprintViewerController.inject = lib_core.clone(editor_2d.AbstractViewerController.inject);
FootprintViewerController.inject.switcherController = ui_extensions.SwitcherController;

module.exports = FootprintViewerController;

FootprintViewerController.prototype.beforeLoad = function(config) {
    var self = this;
    lib_core.Controller.prototype.beforeLoad.call(this, config);

    var editorModel = self.editorController.getModel();
    var editorView = self.editorController.getView();
    var switcherModel = self.switcherController.getModel();

    var showFootprint = function(value, old){
        self.getModel().inspectorSubjects.removeAll();

        if (old) editorModel.interactionModelDataMap.remove(old.data);

        if (value){ // TODO: very similar of makeIMView function in editor2DController
            // make interactionmodel
            var im = new FootprintInteractionModel(value.data, editorModel);
            editorModel.interactionModelDataMap.put(value.data, im);
            self.getModel().inspectorSubjects.add(im);

            // make view
            var view = new FootprintInteractionView(editorView, im, editorView.rootGroup, self.configuration.layers);
            im.onDie({}, function(o){   // if interactionModel dies, remove view as well
                view.removeSvg();
            },101);
        }

    };
    switcherModel.selectedItem.onChange({}, showFootprint);
    showFootprint(switcherModel.selectedItem());
};

FootprintViewerController.prototype.createModel = function () {
    return new FootprintViewerModel();
};
